"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilterIcon = exports.BasicFilterDropdown = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SearchOutlined_1 = __importDefault(require("@ant-design/icons/lib/icons/SearchOutlined"));
var button_1 = __importDefault(require("antd/es/button"));
var input_1 = __importDefault(require("antd/es/input"));
var BasicFilterDropdown = function (_a) {
    var setSelectedKeys = _a.setSelectedKeys, selectedKeys = _a.selectedKeys, confirm = _a.confirm, clearFilters = _a.clearFilters;
    return (react_1.default.createElement(DropWrap, null,
        react_1.default.createElement(DropDown, null,
            react_1.default.createElement(InputArea, { placeholder: "Search", value: selectedKeys[0], onChange: function (e) {
                    return setSelectedKeys(e.target.value ? [e.target.value] : []);
                }, onPressEnter: confirm }),
            react_1.default.createElement(button_1.default, { type: "primary", onClick: confirm, icon: react_1.default.createElement(SearchOutlined_1.default, null) }, "Search"),
            react_1.default.createElement(button_1.default, { onClick: clearFilters }, "Reset"))));
};
exports.BasicFilterDropdown = BasicFilterDropdown;
var SearchIcon = styled_components_1.default(SearchOutlined_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    &&& {\n        color: ", ";\n    }\n"], ["\n    &&& {\n        color: ", ";\n    }\n"])), function (_a) {
    var theme = _a.theme, filtered = _a.filtered;
    return (filtered ? theme.palette.primary.main : null);
});
var DropWrap = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    width: 224px;\n"], ["\n    width: 224px;\n"])));
var DropDown = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: ", ";\n    gap: ", ";\n"], ["\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    padding: ", ";\n    gap: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.spacing.sm;
});
var InputArea = styled_components_1.default(input_1.default)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    grid-column: 1 / span 2;\n"], ["\n    grid-column: 1 / span 2;\n"])));
var FilterIcon = function (filtered) { return react_1.default.createElement(SearchIcon, { filtered: filtered }); };
exports.FilterIcon = FilterIcon;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=tableExtensions.js.map